import { PageTitle } from './PageTitle';
import { PrivacyPolicyText } from './PrivacyPolicyText';
import { IconDownload } from '@tabler/icons';

export const PrivacyPolicy = () => (
  <div
    style={{
      background: 'linear-gradient(#74C9E6, #3174AB)',
      backgroundSize: 'cover',
      minHeight: '100%',
      paddingBottom: '1em',
    }}
  >
    <div
      style={{
        background: '#ffffff',
        padding: '1em',
      }}
    >
      <a href="login">
        <img
          src="assets/images/aquifer-logo-rgb.svg"
          style={{
            margin: '0 auto',
            display: 'block',
            width: '255px',
          }}
        />
      </a>
    </div>
    <section
      style={{
        margin: '1em auto',
        maxWidth: 800,
        background: '#ffffff',
        padding: '1em',
      }}
    >
      <PageTitle>Privacy Policy</PageTitle>
      <a
        href="assets/Aquifer, Inc privacy_policy.pdf"
        download
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 16,
          textDecoration: 'none',
          color: '#3174AB',
          fontWeight: 500,
        }}
      >
        <IconDownload style={{ height: 20, verticalAlign: 'middle' }} />
        Download PDF
      </a>
      <PrivacyPolicyText />
    </section>
  </div>
);
